"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translation = void 0;
var _translation;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var translation = (_translation = {
  400: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  401: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  403: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  404: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  500: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  501: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  At: "at",
  No: "No",
  OK: "OK",
  at: "At",
  is: "is",
  na: "N/A",
  of: "/",
  on: "On",
  xs: "xs",
  to: "to",
  noImage: "No Image",
  catering: 'Catering',
  Yes: "はい",
  add: "Add",
  and: "および",
  eng: "ENG",
  "for": "for",
  ga4: "GA4",
  map: "地図",
  max: "最大 ",
  "new": "NEW",
  now: "now",
  off: "Off",
  phc: "restrooms for physically enabled",
  sms: "WE JUST SENT YOU AN SMS",
  tab: "tab",
  upi: "upi",
  veg: "Veg",
  till: "till",
  from: "from",
  remove: "Remove",
  Okay: "Okay",
  asap: "ASAP",
  call: "Call",
  cart: "Cart",
  date: "Date",
  done: "Done",
  edit: "編集",
  free: "無料",
  help: "help",
  home: "Home",
  list: "一覧",
  more: "More",
  name: "Name",
  noon: "こんにちは",
  oops: "Oops!",
  open: "Opens at {{time}}",
  save: "保存",
  text: "Text",
  time: "Time",
  view: "View",
  when: "When",
  wifi: "wifi ",
  apply: "Apply",
  braze: "Braze",
  close: "Close",
  ecard: "ECard",
  email: "Email*",
  floor: "floor",
  gotIt: "とった'",
  hours: "時間",
  items: "ITEMS",
  local: "en-US",
  login: "Login",
  offer: "Offer",
  order: "注文番号",
  payTm: "paytm",
  promo: "promo",
  afterNoon: "AFTERNOON",
  reset: "Reset",
  retry: "再検索",
  sorry: "Sorry,",
  timer: "timer",
  today: "Today",
  total: "合計額",
  trace: "入っている可能性あり:",
  until: "営業終了",
  Cancel: "キャンセル",
  Submit: "送信",
  Viewed: "Viewed",
  button: "Button",
  callUs: "Call Us",
  cancel: "Cancel",
  change: "変更",
  closed: "営業時間外",
  custom: "カスタマイズ",
  "delete": "削除",
  dineIn: "Dine In",
  donate: "Donate",
  expand: "expand time choices",
  extras: "Extras",
  goBack: "戻る",
  inCart: "In cart",
  kfcTxt: "KFC",
  kfcUrl: "kfc.ca",
  kiosks: "KIOSK",
  myCart: "マイカート",
  nonveg: "Non veg",
  openAt: "Open at",
  orders: "orders",
  pickup: "PICK UP",
  recipe: "Inclusions",
  redeem: "Redeem",
  refill: "お替わり",
  signIn: "ログイン",
  signUp: "Sign Up",
  sortBy: "Sort By",
  ssshhh: "SSSHHH!",
  stores: "My Stores",
  unlock: "Unlock",
  upSize: "Upsize your drink?",
  update: "UPDATE",
  viewUp: "viewup",
  viewed: "表示件数",
  wallet: "Wallet",
  weHave: "We have",
  zoomIn: "Zoom In",
  Locator: "Locator",
  Payment: "お支払い方法",
  "Sign In": "Sign In",
  account: "Account",
  addhope: "Add Hope",
  address: "Addresses",
  balance: "Balance",
  cartAdd: "increase quantity by 1 for",
  cartGst: "消費税",
  checked: "Checked",
  confirm: "確認",
  contact: "Contact",
  cvvText: "CVV*",
  "default": "デフォルト",
  details: "Details",
  dietary: "Dietary",
  editbox: "editbox",
  editing: "editing",
  evening: "こんばんは",
  findKfc: "Find a KFC",
  getHelp: "サポートに問い合わせる",
  heading: "heading",
  inStore: "In Store",
  kJ_text: "kJ",
  kfcFood: "ケンタッキーフライドチキン",
  kfcMenu: "メニュー",
  kfcNews: "KFC news and announcements",
  message: "メッセージ",
  morning: "おはようございます",
  nearYou: "お近くの KFC",
  oneItem: "ITEM(S)",
  openNow: "営業中 • 営業終了",
  openPDP: "Open PDP",
  openPLP: "Open PLP",
  parking: "パーキング",
  payCash: "pay-by-cash",
  payment: "Payment",
  phonePe: "phonepe",
  present: "アレルゲン:",
  privacy: "プライバシーポリシー",
  receipt: "レシート",
  signOut: "サインアウト",
  support: "SUPPORT",
  todayAt: "Today at ",
  twitter: "Twitter",
  updated: "Custom",
  validTo: "Valid to",
  viewMap: "View Map",
  viewOur: "View our",
  viewing: "表示中",
  viewour: "View our",
  weFound: "検索結果件",
  weSaved: "We saved this order as an occasion",
  zoomOut: "Zoom Out",
  OrderNow: "Order Now",
  addOnMsg: "Add-On(s) included in your order",
  address2: "Address Line 2*",
  birthday: "誕生日",
  calories: "calories",
  canceled: "Cancelled",
  carousal: "carousel view enabled",
  cartItem: "商品",
  checkBox: "checkBox",
  checkout: "CHECKOUT",
  clearAll: "Clear All",
  collapse: "collapse time choices",
  "continue": "Continue Ordering",
  delivery: "お届け（デリバリー）",
  dineInAt: "Dine-in At",
  editName: "名前を編集する",
  emptyCvv: "Enter CVV number",
  emptyMsg: "Please enter your order name.",
  emptyPin: "Enter pin number",
  endingIn: "Ending in",
  expanded: "expanded",
  external: "external",
  facebook: "Facebook",
  filterBy: "Filter By",
  freeWifi: "フリー wifi",
  fullName: "氏名*",
  fullname: "fullname* editbox",
  getTouch: "お問い合わせはこちらから",
  giftCard: "Gift Card",
  hoursCap: "HOURS",
  internal: "internal",
  kfcImage: "kfc image",
  kfcLover: "KFC LOVER",
  listview: "listview enabled",
  loadMore: "もっと表示",
  location: "Location",
  menuView: "Menu",
  mmddText: "MM / YY*",
  moreInfo: "詳しくはこちら",
  needHelp: "Need Help?",
  newPrice: "New Price",
  nickName: "nickName",
  oldPrice: "Old Price",
  onlyText: "only text",
  open24Hr: "24 時間営業",
  orderFor: "Order for",
  orderMsg: "orci, eget tempus risus.",
  orderNow: "Order Now",
  per_gram: "100g あたり",
  postcode: "郵便番号",
  quantity: "数量",
  readLess: "Read Less -",
  readMore: "Read More +",
  refunded: "Refunded",
  restroom: "トイレ",
  savedkfc: "SAVED KFC",
  schedule: "SCHEDULE",
  selected: "selected",
  subTotal: "Subtotal",
  takeAway: "Pick up",
  takeaway: "Pick up",
  terraces: "テラス",
  thankYou: "THANK YOU",
  tomorrow: "Tomorrow",
  tryAgain: "Please Try Again",
  viewCart: "View Cart",
  viewMenu: "View menu",
  ERROR_ALT: "error",
  EnteraCVV: "Enter CVV number",
  addCoupon: "Add a Coupon",
  addToCart: "追加する",
  allergens: "アレルゲン情報",
  amenities: "店舗設備",
  apiButton: "Call API",
  askForOTP: "YOUR DRIVER WILL ASK YOU FOR THIS OTP ON ARRIVAL",
  breakfast: "モーニング",
  cartItems: "商品",
  cartTitle: "CART",
  changeCap: "Change",
  collapsed: "collapsed",
  completed: "Completed",
  contactUs: "CONTACT US",
  copyRight: "Copyright © KENTUCKY FRIED CHICKEN JAPAN LTD. 2022 All Rights Reserved. ",
  customise: "カスタマイズ",
  customize: "Customise",
  doYouWant: "Do you want to",
  driveThru: "ドライブスルー",
  emptyName: "Enter your Name",
  enjoyMeal: "おいしい食事をお楽しみください！",
  enterCode: "Enter Code",
  enterName: "Please enter name",
  foodCourt: "フードコート",
  giveAName: " give it a name!",
  greetings: "Hello",
  hometitle: "HOME",
  instaLink: "instagram link",
  instagram: "Instagram",
  keepOrder: "注文を続ける",
  labelName: "Name",
  leaveText: "Leave",
  leftArrow: "left arrow",
  letUsKnow: "Let us know you better",
  menuTitle: "KFC メニュー",
  moreTitle: "MORE",
  myAccount: "アカウント",
  noAddress: "You don’t have any delivery addresses yet.",
  nutrition: "栄養成分 ",
  offerDeal: "Deals & Offers",
  onlyImage: "only image",
  openToday: "Open Today at",
  openUntil: "Open Until",
  orderFrom: "ORDER FROM",
  orderHash: "注文番号 #",
  orderMode: "ご注文",
  orderName: "注文名",
  orderType: "注文方法",
  ordersNow: "orders now.",
  per_serve: "1 食分あたり",
  pinNumber: "Pin Number*",
  saveOrder: "Save This Order",
  savetoFav: "Save Favourite Order",
  scheduled: "予約",
  selectDay: "SELECT A DAY",
  selectKFC: "店舗を選択",
  sorryText: "sorry,",
  storeMenu: "Store Menu",
  subscribe: "配信登録する",
  todayASAP: "Today, ASAP",
  topSeller: "TOP SELLER",
  totalCost: "Total cost:",
  unChecked: "unChecked",
  unchecked: "Unchecked",
  unlocksIn: "UNLOCKS IN",
  wantToAdd: "Want to add or modify?",
  welcomeTo: "WELCOME TO ",
  yesDelete: "Yes, Delete",
  yesKeepIt: "Yes, Keep It",
  yourOrder: "ご注文内容",
  addACoupon: "Add a Coupon",
  addFavName: "名前を付ける",
  addToOrder: "注文に追加する",
  addressOne: "Addresses 1",
  arrowImage: "Arrow",
  backButton: "Back",
  backToCart: "カートに戻る",
  backToMenu: "メニューに戻る",
  backtomenu: "Back to menu",
  browseMenu: "メニューを見る",
  cardExpiry: "MM / YYYY*",
  cartRemove: "削除",
  closedNext: "明日営業",
  contactKFC: "CONTACT KFC",
  creditCard: "credit-card",
  deliveryTo: "Delivery To",
  dineInInfo: "DINE IN INFO",
  dineInText: "will be ready for Dine-in by",
  disclaimer: "免責事項",
  emailLabel: "Email",
  expiredMsg: "Hurry up! This exclusive coupon is expiring soon!",
  favourites: "お気に入り",
  giftAmount: "GIFT AMOUNT",
  giftpinNum: "Pin Number",
  handItToMe: "手渡し",
  hereToHelp: "WE'RE HERE TO HELP IF YOU REQUIRE MORE INFORMATION ",
  hiddenText: "KFC | Order KFC Chicken Online & Find Restaurants",
  inprogress: "In Progress",
  invalidCvv: "Invalid CVV number",
  invalidMsg: "Name must have minimum 3 and maximum 20 characters. Special characters Not allowed.",
  invalidPin: "Invalid Pin",
  isOnTheWay: "ドライバーがお届け先住所に向かっています",
  itemInCart: "Item in your cart",
  itemUnaval: "Items are unavailable.",
  mainEntree: "Main Entree",
  maxtextEnd: "カスタマイズの追加が選択されています。変更するにはどれか １ つを削除してください。",
  myFavorite: "お気に入り商品",
  netbanking: "net-banking",
  noFavStore: "You don’t have any favourite stores yet.",
  offerDeals: "OFFERS & DEALS",
  orderAgain: "Order Again",
  otherPages: "Other Pages",
  outOfStock: "Out of Stock",
  pastOrders: "past orders",
  placeOrder: "注文する",
  playground: "キッズスペース",
  preparedBy: "ご注文店舗",
  processing: "準備中",
  quickOrder: "Quick Reorder",
  reckOnText: "また注文するご予定がありますか？",
  reorderBtn: "再注文",
  resendCode: "Resend code",
  retainCart: "Please add your food again to cart",
  rightArrow: "right arrow",
  savedOrder: "Saved this order in",
  searchMenu: "メニューを検索する",
  secretMenu: "secret menu",
  selectText: "You must select",
  selectTime: "SELECT A TIME",
  signUpText: "Sign Up",
  socialIcon: "social icons view",
  startOrder: "注文を開始する",
  takeMeHome: "Take Me Home",
  termsOfUse: "Terms of use",
  termsofuse: "Terms of use",
  trackOrder: "Track Order",
  unselected: "unselected",
  updateCart: "Update Cart",
  useAddress: "この住所を使用する",
  viewOffers: "View",
  wantToKnow: "What would you like to know?",
  yes_Remove: "削除する",
  yourAllSet: "YOU’RE ALL SET",
  yourOrders: "YOUR ORDERS",
  yourSearch: "検索",
  ClosedDueTo: "Closed due to",
  DineInStore: "Walk-In the Store",
  GSTincluded: "消費税込み",
  SERVES_TEXT: "serves",
  SelectStore: "店舗を選択",
  aSecondText: "A SECOND.",
  addHopeLogo: "Add Hope Logo",
  addHopeText: "Our goal is to feed 20 million people by 2021.",
  addedToCart: "added to cart!",
  addedToYour: "に追加されました",
  addressHint: "Entering text into the input field will trigger the suggestions of address",
  arrvingSoon: " is arriving now",
  atWithSpace: " at ",
  balanceText: "Balance:",
  browseStore: "Browse Store",
  bucketEmpty: "Oops ! looks like there is no order history for you. Lets start an order",
  buyGiftCard: "Buy Another Gift Card",
  cancelOrder: "SORRY, WE’VE HAD TO CANCEL YOUR ORDER.",
  cartAllHope: "All Hope",
  cartSubText: "Any eligible discounts will be applied at the next step before placing your order.",
  cartViewAll: "View All",
  changeStore: "Change your store settings",
  clearSearch: "検索条件をクリアする",
  closeButton: "Close button",
  closingSoon: "Closing soon • until",
  collectedAt: "(Time) に受け取りました",
  contactInfo: "CONTACT INFO",
  contactless: "非接触",
  dateOfBirth: "誕生日",
  delToastMsg: "Successfully Your Occasion Delete",
  deliveredAt: "DELIVERED AT",
  deliveryFee: "配達料",
  disposition: "disposition",
  downloadApp: "Download App",
  emptyExpiry: "Enter Expiry Date",
  eneryKJText: "エネルギー (kJ)",
  errorButton: "Tap me to see an error handler",
  findOpenKfc: "Find Open KFC",
  foundDriver: "WE’VE FOUND YOUR DRIVER",
  giftCardnum: "Gift Card Number",
  goodEvening: "Good Evening",
  gstIncluded: "合計（税込）",
  iAmHereText: "I’m Here",
  information: "INFORMATION",
  invalidCard: "Please Enter a Valid Card Number",
  invalidName: "Invalid Name",
  itemUpdated: "ITEM UPDATED",
  keepShoping: "Keep Shopping",
  kfcGiftCard: "KFC gift card",
  letsgetcook: "LET’S GET COOKIN’",
  mealOptions: "ミールメニュー",
  myFavStores: "MY FAVOURITE STORES",
  myOccasions: "ORDER AGAIN",
  no_internet: "We're sorry, we're having trouble with your connection. Please check your WiFi or cellular service and try again.",
  notSelected: "not selected",
  notSignedIn: "Not Signed In",
  orderLookup: "Order lookup",
  otherWallet: "other-wallet",
  permanently: "PERMANENTLY",
  phoneNumber: "電話番号*",
  pickupOrder: "PICK UP Order",
  pickupTitle: "ネットオーダー・KFCアプリに関するお問い合わせ",
  productItem: "Sorry, this food item is",
  rdpRestroom: "ユニセックストイレ",
  refineItems: "Refine Items",
  removeTitle: "Remove from Favourites",
  reorderCaps: "REORDER",
  reviewOrder: "注文を確認",
  saveAddress: "SAVE THIS DELIVERY ADDRESS TO YOUR ADDRESS BOOK",
  saveChanges: "変更を保存する",
  selectStore: "Select your store",
  setLocation: "位置情報を設定する",
  signInToast: "Thank you for signing up! Happy to have you!",
  sorryUnaval: "Sorry, some items become unavailable.",
  storeClosed: "Sorry, %storeName% is currently closed. Please select a different store or order during working hours",
  trackOrders: "Track Orders",
  twitterLink: "twitter link",
  unavailable: "選択できません",
  unsubscribe: "配信停止",
  upSellTitle: "KFC からのおすすめ",
  viewAllDeal: "View All Deals",
  viewAllMenu: "View All Menu",
  viewProduct: "商品を表示",
  viewReceipt: "レシートを表示",
  viewallFaqs: "View all FAQs",
  viewdetails: "詳細表示",
  walkInStore: "Pick up from the store",
  welcomeBack: "ようこそ",
  whenYouHere: "WHEN YOU’RE HERE.",
  yourAccount: "your account",
  CVVisinvalid: "CVV is invalid",
  DiscountText: "Discount",
  GoBackToCart: "and click Back to Cart to go back Cart section.",
  GoToHomePage: "Go to HomePage",
  Instructions: "deliveryInstructions",
  KfcToYourCar: "KFC to Your Car",
  accountTitle: "アカウント",
  addressSaved: "Address Saved",
  addressValue: "address",
  businessDays: " BUSINESS DAYS",
  callKFCstore: "お客様サービス係",
  cartCheckout: "お支払い",
  cartIncluTax: "Delivery Fee",
  cartInfoText: "Menu pricing varies between order types.",
  cartSubTotal: "小計",
  cartfaqtitle: "よくあるご質問",
  cateringMenu: "Catering Menu",
  cateringText: "ケータリング",
  changePickup: "Change to Pick Up",
  changedPrice: "Items have changed price.",
  checkBalance: "Check Balance",
  chooseAStore: "Choose a Store",
  closePopOver: "Tap me to close popover1",
  closedStatus: "CLOSED",
  couponCopied: "Success! Your coupon has been copied!",
  currentOrder: "CURRENT ORDER",
  cutomizeYour: "をカスタマイズする",
  deliverToYou: "%storeCount% KFC that deliver to you",
  deliveryInfo: "デリバリー情報",
  discountCode: "Discount Code",
  dropdownText: "Language",
  editItemText: "Edit Item",
  editQuantity: "EDIT QUANTITY",
  editorPickup: "Editor's Pick & Customer Favourite",
  emailAddress: "メールアドレス*",
  enterMessage: "Enter message here.",
  entrYourMail: "Enter your email",
  facebookLink: "Facebook link",
  failureretry: "Retry",
  fingerLickin: "Finger Lickin’ Got It! Added to your cart!",
  footer_links: "footer-links",
  getDirection: "経路案内",
  giftErrTitle: "OH NO!",
  greetingGood: "GOOD",
  hasNowClosed: "HAS NOW CLOSED",
  hasScheduled: "has scheduled",
  haveQuestion: "Still have a question?",
  helpDropdown: "お問い合わせの種類*",
  inExtrasText: "in Extras",
  instructions: "特記事項",
  invaidInputs: "Your order could not be found",
  keepBrowsing: "Keep Browsing",
  keepShopping: "Keep Shopping",
  kfcWebAndApp: "KFC アプリ/ウェブ Lockup",
  makeItACombo: "MAKE IT A COMBO",
  mobileNumber: "Mobile Number",
  nameExistMsg: "There is already another favourite with this name. Enter a different order name",
  nextLocation: "next location",
  noNearestKFC: "No nearest KFC store",
  noOrderFor12: "No orders have been placed in the past 12 months.",
  nokfcnearyou: "残念ながら付近にKFCの店舗がございません。",
  notavailable: "Not available",
  offerApplied: "Offer Applied",
  offersForYou: "OFFERS FOR YOU",
  openTomorrow: "Open Tomorrow at {{time}}",
  orderDetails: "order details",
  orderHistory: "注文履歴",
  orderItAgain: "再注文はこちらから",
  orderReceipt: "Order Receipt",
  orderSummary: "ご注文内容",
  orderhistory: "注文履歴",
  outOfService: "Out Of Service",
  payCashTitle: "Cash on Delivery",
  pdpAddToCart: "カートに追加",
  personalInfo: "アカウント情報",
  pleaseSelect: "Please Select",
  quickReorder: "Quick Reorder",
  reOrderAgain: "ORDER IT AGAIN",
  savedAddress: "Saved Address",
  savedMessage: " 情報を保存しました",
  selectATopic: "Select a Topic",
  selectOption: "Select Your Options",
  signInButton: "Sign-in to see your saved addresses",
  signInSignUp: "Sign in / Sign up",
  signOutText1: "You’re signed Out.",
  signOutText2: "We’re gonna miss you.",
  signinButton: "Sign-in to see your saved addresses",
  singleResult: "Result for",
  social_icons: "social-icons",
  takeawayFrom: "Pick up From",
  takeawayInfo: "お持ち帰り情報",
  thatNotRight: "お間違いがないか今一度ご確認ください",
  tokenExpired: "Your session has expired. Please relogin or continue as guest.",
  tradingHours: "営業時間",
  wantToModify: "Want to add or modify? ",
  weAreWorking: "We are working on",
  yourCatering: "YOUR CATERING ORDER WILL BE READY FOR PICK UP IN STORE",
  yourDelivery: "Your delivery by",
  yourLocation: "住所",
  FeedbackEmail: "kfcfeedback@yum.com",
  Order_Summary: "KFC Order Summary",
  ScheduleOrder: "Schedule Order",
  addHopeHeader: "Donate ₹5.00 Tick to Add Hope.",
  addNewAddress: "住所を追加する",
  addNewProduct: "Add new product",
  addToOccasion: "お気に入りに追加",
  address2Error: "Please enter a valid address.",
  addressHeader: "ADDRESS HEADER",
  alreadyMember: "会員登録はお済みですか？",
  aptSuiteFloor: "ビル・建物名/階",
  browseTheMenu: "Browse The Menu",
  bundleOptions: "セットメニュー",
  buttonPopOver: "Tap me to show second popover",
  cartDownArrow: "downArrow",
  cartMinusGrey: "decrease quantity",
  cartRemoveAll: "Remove All",
  cartRighttick: "Right Tick",
  cateringOrder: "CATERING ORDER",
  checkoutAlert: "This is an error alert — check it out!",
  clearOccasion: "Clear order name",
  contentButton: "Tap me to see a content button",
  continueToPay: "Continue to Payment",
  couponSuccess: "Success! Your coupon has been applied!",
  currentOrders: "現在のご注文",
  defaultString: "to order your favourite Chicken.",
  deleteAccount: "アカウントを削除する",
  deliveryHours: "お届け時間",
  deliveryOrder: "DELIVERY Order",
  deliveryTitle: "商品や店舗に関するお問い合わせ",
  dineInOptions: "DINE IN OPTIONS",
  editFavourite: "Edit Favourite Name",
  editOrderName: "EDIT ORDER NAME",
  editOrderType: "edit order type",
  effectiveDate: "Effective Date:",
  emailHelpText: "有効なメールアドレスを入力してください。",
  emptyCardName: "Enter Full Name",
  emptyFavStore: "お気に入り店舗が登録されていません。",
  errorDeleting: "Error in deleting account",
  exclusiveDeal: "EXCLUSIVE DEAL",
  extraToppings: "extra toppings",
  findingDriver: "店舗内で調理を開始する前にドライバーを見つける...",
  generic_error: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favourite Chicken.",
  getDirections: "Get Directions",
  giftCardTitle: "GIFT CARD",
  haveAQuestion: "サポートが必要ですか？",
  invalidExpiry: "Invalid Expiry Date",
  invalidQRCode: "Invalid QR code would you like to explore nearby KFC store.",
  isAlmostThere: "間もなく到着します",
  isClosedDueTo: "is currently closed due to",
  isClosingSoon: " is closing soon.",
  kfcRestaraunt: "KFC Restaurant",
  largeCarryBag: "Large Carry Bag",
  lastNameLabel: "Last Name",
  leaveatMyDoor: "置き配",
  leftArrowCaps: "Left Arrow",
  mandatorynote: "Note: * Indicates required field",
  maxOrderPromo: "You have reached the maximum order amount for this Promo.",
  morePageTitle: "Web Title",
  nameIsInvalid: "Name cannot contain special characters.",
  nameThisOrder: "Order Name",
  occasionTitle: "注文名",
  oneItemUnaval: "Item is unavailable.",
  onlinePayment: "If you have made online payment,",
  oopsWentWrong: "Oops something went wrong!",
  orderAccepted: "ORDER ACCEPTED",
  orderDateTime: "ORDER DATE & TIME",
  orderForLater: "Order for Later",
  orderOnTheWay: "お届け中です",
  orderPastTime: "We’re sorry, but your current order’s scheduled time has passed. Please reschedule your order time to continue.",
  orderReceived: "お渡し済み",
  paymentHeader: "お支払い",
  pdpUpsizeDesc: "ポテトL ＆ドリンク L",
  phoneHelpText: "有効な携帯番号を入力してください。",
  pickUpSupport: "Pick Up Support",
  pickupMethods: "Pick Up Methods",
  postcodeError: "住所、または郵便番号を入力してください",
  promosRewards: "プロモーション & 特典",
  questionForUs: "Question for us?",
  rdpNoDelivery: "Sorry! Delivery is not currently available from this restaurant.",
  refundMessage: "Your order transaction has failed and your refund is being processing. Please contant us if you have any questions.",
  removeFavMenu: "Remove From Favourite Menu",
  roundTheClock: "24x7",
  saveThisOrder: "Save This Order",
  scheduleOrder: "Schedule Order",
  scheduledTime: "Scheduled time",
  selectedSlide: "selected slide",
  signInAccount: "SIGN IN TO YOUR ACCOUNT",
  spinnerButton: "Tap me to see a spinner",
  startNewOrder: "新たに注文を開始",
  thatsAllFolks: "That’s all, folks",
  thatsAllRight: "THAT AIN’T RIGHT",
  tickToAddHope: "Tick to Add Hope.",
  trackDelivery: "Track Delivery",
  useMyLocation: "位置情報を利用する",
  viewAllPromos: "全てのプロモーション & 特典を表示する",
  welcomeBackTo: "WELCOME BACK TO ",
  yourCartEmpty: "カートに商品が入っていません。注文を開始しましょう！",
  yourPastOrder: "Your Orders",
  Congratulation: "CONGRATULATIONS!",
  Page_Title_FAQ: "KFC FAQ",
  Page_Title_Faq: "KFC FAQ",
  accoundSetting: "アカウント設定",
  accountFavPage: "Account - Favourites",
  addToFavourite: "Add to Favourite",
  addToYourOrder: "pieces in total to add this to your Order.",
  addressUpdated: "Address Updated",
  backToCheckOut: "Back to Checkout",
  bankTextHeader: "Bank",
  browsecategory: "browse categories",
  buttonTemplate: "Template button",
  callRestaurant: "Call Restaurant",
  cardNumberText: "Card Number*",
  cartMinusBlack: "decrease quantity by 1 for",
  changeDelivery: "Change to Delivery",
  checkBackAgain: "後日、お客様の向けのプロモーション & 特典を確認ください。",
  checkoutFaster: "CHECKOUT FASTER",
  closeGiftClose: "Close CHECK YOUR GIFT CARD BALANCE dialog",
  comboSubHeader: "Would you like to make it a combo? Select one of the options below.",
  confirmChanges: "Confirm Changes",
  delBtnOccasion: "Delete this occasion",
  deliveryDriver: "配達ドライバー",
  deliverycharge: "Delivery Fee",
  deriverArrived: "Deriver arrived",
  dippingSauceId: "C-30055-prod",
  discardChanges: "Discard Changes",
  driveThruQuote: "DRIVE UP AND QUOTE YOUR ORDER NUMBER, PICK UP FROM THE collection window AND Enjoy YOUR MEAL",
  driverArriving: "到着しました",
  editSelections: "EDIT SELECTIONS",
  emailMarketing: "メール",
  emptyCouponMsg: "Enter your Coupon Code.",
  emptyOccasions: "You haven’t created any occasions yet",
  emptyOccassion: "Occasion name should not be empty",
  enterOrderName: "Please enter your order name.",
  firstNameLabel: "First Name",
  forMembersOnly: "メンバー限定",
  giftcardNumber: "Gift Card Number*",
  giftcardTender: "giftcard",
  giveUsYourName: "GIVE US YOUR NAME OR ORDER NUMBER WHEN YOU'RE HERE.",
  gladStaticText: "Glad I could help",
  googleApiError: "Sorry, Google location services are down. Please check your internet connection and retry.",
  hasBeenDelayed: "has been delayed",
  insideYourMeal: "INSIDE YOUR MEAL",
  invalidEmailId: "Invalid E-mail id",
  invalidOrderId: "Not A Valid Order Number",
  kfcLocalOffers: "Select a kfc to see local offers",
  legalInfoText1: "成人の平均摂取カロリーは 8700kcal です。",
  legalInfoText2: "^ Pepsi Max, Pepsi, Pepsi Freeze & Mountain Dew Freeze contains caffeine. Mountain Dew Freeze is not recommended for children, pregnant or lactating women or individuals sensitive to caffeine.",
  maxBucketToast: "A max bucket value of $100 to Checkout.",
  maxtextInitial: "個選択済み",
  nameExistError: "There is already a saved address with this name.",
  nameOnCardText: "Name on Card*",
  nationalOffers: "National Offers",
  noneditionable: "is not editable",
  noteItemsAdded: "Please note your items will be added to your cart.",
  occassionLabel: "Occasion Name",
  orderDelivered: "Order delivered",
  orderFailedMsg: "Input necessary messaging here. Ut in viverra tellus enean pharetra enim",
  outForDelivery: "Out For Delivery",
  paymentOptions: "お支払い方法",
  pdpChooseStore: "受け取り方法と店舗を選択して、お取り扱い状況と価格をご確認ください",
  pdpUpsizeTitle: "サイズアップ",
  plsReviewOrder: "please review your order",
  popOverButton1: "Tap me to see first popover",
  processingYour: "ご注文の商品を準備しています",
  readyForDineIn: "READY FOR DINE-IN",
  readyForPickup: "お渡しする準備ができております",
  readyToCollect: "Ready to collect",
  recaptchaLabel: "Recaptcha",
  removedFromFav: "お気に入りから削除する",
  rightArrowCaps: "Right Arrow",
  saveAddressBtn: "Save Delivery Address",
  savedAddresses: "Saved Addresses",
  searchThisArea: "Search this area",
  secretMenuView: "Secret Menu",
  secureCheckout: "Secure Checkout",
  selectCarryBag: "Select large carry bag",
  selectQuantity: "SELECT QUANTITY",
  sortVisitError: "問題が発生したため、やりなおしてください。",
  specialCharErr: "Name cannot contain special characters",
  startYourOrder: "注文を開始する",
  storeCloseText: "Store Closed",
  subscribeEmail: "I want to know about the cool stuff at KFC on Email & SMS (I know I can unsubscribe anytime).",
  suggestionText: "Entering text into the input field will trigger the suggestions of search",
  switchToDineIn: "Switch to Dine-in",
  technicalError: "Open Now (online ordering unavailable)",
  thatsAllForNow: "THAT’S ALL FOR NOW",
  trackYourOrder: "Track Your Order",
  turnedNoResult: "returned no results",
  updatedAddress: "住所が更新されました",
  whatSecretMenu: "WHAT SECRET MENU?!",
  BrowseStoreMenu: "Browse store menu",
  MODALHEADERTEXT: "Customise Your",
  MultipleResults: "件の検索結果　検索語句：",
  Page_Title_Cart: "KFC Cart",
  Page_Title_Help: "KFC Help",
  YourKFCLocation: "店舗",
  addToFavourites: "add to favourites",
  addressErrorMsg: "Address Nickname can’t be the same as a previously saved address.",
  browseMenuTitle: "Browse the selected restaurant menu.",
  cancelSelection: "Cancel selections",
  cartAddMoreFood: "Add More Food",
  cartAddMoreMenu: "Add More Menu",
  cartGstIncluded: "GST Included",
  cartOffersDeals: "Apply Promos & Rewards",
  cartSummaryNote: "Note: Any eligible promos, rewards and discounts will be applied at the next step before placing your order.",
  categoriesImage: "Browse categories image",
  cateringWarning: "Catering orders require Pick Up from the restauarant.",
  changedYourMind: "変更しますか？",
  checkedInStatus: "checkedIn",
  comboSubHeader1: "Would you like to make it a combo?",
  comboSubHeader2: "Select one of the options below.",
  completedOrders: "これまでのご注文",
  continueAsGuest: "Continue As Guest",
  continueExplore: "continue exploring our menu option",
  continuePayment: "Continue to Payment",
  currentlyClosed: "is currently closed. Please select a different store or order during working hours.",
  delAddressTitle: "Are you sure you want to remove this occasion?",
  deliveredAround: "will be delivered around",
  deliveryAddress: "お届け先住所",
  deliveryOptions: "デリバリーオプション",
  deliverySupport: "Delivery Support",
  doNotSellMyInfo: "Do not sell my personal information",
  editbtnOccasion: "名前を編集する",
  emailStaticText: "メールアドレス",
  emptyCardNumber: "Enter Card Number",
  emptyCartBanner: "Empty Cart Banner",
  emptyPostalCode: "Enter Billing Postal Code",
  emptySavedStore: "お届け先住所が登録されていません。",
  enquiryDropdown: "What is this KFC App Enquiry about?*",
  exclusiveOffers: "Sign In to See Exclusive Offers & Deals",
  exploreCatering: "ケータリングを見る",
  exploreFoodItem: "Explore our various other food items",
  favNameExistMsg: "There is already another favourite with this name.",
  favouriteOrders: "Favourite Orders",
  feedbackSuccess: "Success",
  findNearByStore: "Find nearby store",
  giftCartMessage: "Message",
  giftPurchaseErr: "It seems there is some issue with the gift card purchase",
  infoCorrectText: "2023 年 5 月時点の情報",
  invalidPhoneNum: "Invalid Phone number",
  itemUnavailable: "Unavailable",
  loadMoreFavMenu: "Load More Favourite Menu",
  mandatoryFields: " * all fields are required",
  myOccassionText: "My Occasions",
  nameOrderNumber: "GIVE US YOUR NAME OR ORDER NUMBER",
  newOffersForYou: "new offers for you!",
  onePromoApplied: "プロモーションが適用されています。削除してから追加してください。",
  otherWalletText: "Other Wallet",
  paymentdeclined: "Unfortunately, we are unable to process your payment right now. The payment has been declined by the payment provider.",
  phoneStaticText: "電話番号",
  pickupPromotion: "Promotion is for Pick Up",
  processingOrder: "ご注文の商品を準備しています。しばらくお待ちください。",
  refundInitiated: "refund-initiated",
  refundinitiated: "refund-initiated",
  saveOrderFaster: "SAVE YOUR ORDERS AND CHECKOUT FASTER",
  savedAddressMsg: "Saved this order in My Favourite Menu.",
  scheduledPickup: "is scheduled to be picked up at",
  searchAndFilter: "Search",
  seePromosForYou: "お客様向けのプロモーションを表示する",
  selectOrderType: "Select Order Type",
  sentToPosStatus: "sent-to-pos-completed",
  setYourLocation: "Set Your Location",
  signInToAccount: "SIGN IN TO YOUR ACCOUNT",
  takeawayOptions: "PICK UP OPTIONS",
  termsConditions: "Terms and Conditions",
  unavailabeItems: "Sorry, items in your cart have become unavailable. If you wish to checkout, these unavailable items will be removed from your cart.",
  viewMoreDetails: "View More Details",
  welcomeBackText: "おかえりなさい",
  KfcToYourCarDesc: "Avoid the hassle of walking into crowded places. We'll come to you.",
  Order_Processing: "KFC Order Processing",
  Page_Title_Login: "KFC Login",
  TotalOver100Text: "Whoops Total order is over $100",
  beReadyForPickup: "BE READY FOR PICK UP IN STORE",
  browseMenuHeader: "メニューカテゴリー",
  btnRemindMeLater: "Remind Me Later",
  cancelButtonText: "キャンセル",
  carousalDisabled: "carousel view disabled",
  cartOffersForYou: "Offers & deals for you",
  cateringSchedule: "Catering Schedule",
  checkGiftBalance: "CHECK BALANCE",
  checkInAheadTime: "Please ensure you check in your order ahead of this time",
  checkInAtInStore: "TAP BELOW WHEN YOU'VE ARRIVED IN STORE",
  chooseAnotherWay: "Choose another way to pay",
  chooseAnyProduct: "CHOOSE ANY OF THESE PRODUCTS",
  confirmSelection: "Confirm Selection",
  confirmYourOrder: "CONFIRMING YOUR ORDER.",
  contactInfoTitle: "Contact Info",
  continueAsAGuest: "Continue as a Guest",
  continueToMyCart: "カートを確認する",
  createKfcAccount: "KFCアカウントを作成する",
  deleteConfirmMsg: "Are You Sure you Want TO Delete this Delivery Address?",
  dismissSelection: "Dismiss selections",
  editPersonalInfo: "Edit Personal Info",
  emailPlaceholder: "Eメール*",
  emptyEmailErrMsg: "受信用メールアドレスを入力してください。",
  enterYourOrderNo: "Please Enter your order Number",
  estimatedArrival: "到着予定時間",
  estimatedarrival: "Estimated arrival",
  favouritesHeader: "Favourites",
  feedbackHelpText: "Please enter your feedback.",
  getOccasionEmail: "Get occasional emails about site improvements or changes",
  giftCardPurchase: "gift-card-purchase",
  giftMessageTitle: "MESSAGE",
  hasBeenConfirmed: "has been confirmed for",
  iAmElseWhereText: "I’m Elsewhere",
  includedToppings: "included toppings",
  itemAddedToOrder: "Item(s) added to order",
  itemNotAvailable: "Items in this order are not currently available at this store right now.",
  lastNameHelpText: "Please enter your last name",
  listviewDisabled: "listview disabled",
  makingOrderFresh: "we’re MAKING your order FRESH",
  moreCrowdPleaser: "みんなで楽しめるメニュー",
  morePageSubTitle: "Web Sub Title",
  netbankingString: "Netbanking",
  occasionEditName: "Edit Order Name",
  occasionGiveName: "ADD FAVOURITE ORDER",
  onlinePaymentMsg: "a refund will appear on your original payment source within 7-10 business days.",
  orderNameEditBox: "Order name edit box",
  orderNumberError: "[X] 桁の注文番号を入力してください",
  orderReadyInJust: "しばらくお待ちください",
  outOfStockNotify: "Sorry, items in your cart has become unavailable. Please review before checkout.",
  pdpToastShowTime: "3000",
  phonePlaceholder: "電話番号*",
  pickupFromWindow: "ドライブスルーの受け取り窓口で注文を受け取る",
  previousLocation: "previous location",
  processingRefund: "返金",
  productListModal: "Open product list modal",
  rdpaccessibility: "バリアフリー",
  readyToMakeOrder: "we’re ready TO MAKE YOUR ORDER",
  recipientEmptErr: "Invalid recipient email",
  removeFavourites: "Remove from Favourites",
  review_Condition: "Please review the conditions below.",
  scheduleDelivery: "Schedule delivery",
  searchByLocation: "Search by State, City, or Zip",
  seeIncludedItems: "セット内容を表示",
  selectOrderTitle: "HOW WOULD YOU LIKE TO RECEIVE YOUR ORDER?",
  signAndSaveOrder: "Sign Up & Save Order",
  signOutFailText1: "You’re signed out",
  signOutFailText2: "Kindly Sign In again",
  sitemapPageTitle: "KFC Sitemap",
  specificDropdown: "Can you be more specific?*",
  storeClosedError: "$storeName is currently closed. Change store below to find another restaurant.",
  storeClosedTitle: "is currently closed.",
  storeOfflineMain: "can no longer serve this order.",
  submitButtonText: "Submit",
  switchToDelivery: "Switch to Delivery",
  switchToTakeaway: "お持ち帰りに変更する",
  thanksStaticText: "ありがとうございました",
  thatDeliverToYou: "配達元店舗",
  unselectCarryBag: "unselect large carry bag",
  viewAllOfferText: "view all offer",
  viewInFavourites: "お気に入りを表示",
  viewOrderHistory: "View Order History",
  visitedDateError: "注文日を入力してください",
  weAreWorkingYour: "We are working on your order",
  Page_Title_Offers: "KFC Deals and Offers",
  SignInToSeeOffers: "Sign In to see exclusive offers & deals",
  addItemToCartText: "Added item to the cart",
  cancelOrderRefund: "WE WILL REFUND YOUR PAYMENT IN FULL WITHIN ",
  cancelPickupOrder: "ARE You Sure you WANT TO CANCEL YOUR PICK UP ORDER?",
  cartError_explore: "Sorry, this food is ",
  cartLineItemImage: "lineItemImage",
  cashOnDeliveryMsg: "Sorry for the inconvenience, your order has been cancelled by our store.",
  checInAtDriveThru: "お店に到着したらチェックインをしましょう",
  closePaymentModal: "Close Select your Payment Dialog",
  codeExpireMessage: "Your code will expire in",
  confirmSelections: "選択を確定する",
  deleteAccountText: "アカウントを削除いたしました。またのご利用をお待ちしております。",
  deliveryPromotion: "Promotion is for Delivery",
  dineInStoreClosed: "Sorry, dine-in is not currently available right now.",
  dismissSelections: "選択を解除する",
  dobToolTipMessage: "お誕生日特典があります！いったん保存すると変更できません。",
  enquiryStaticText: "お問い合わせ内容",
  feedbackSuccessOk: "OK",
  findNearRestorant: "Find nearby restaurant",
  firstNameHelpText: "Please enter your first name.",
  fullPaymentRefund: "Full payment will be refunded within 3-5 business days.",
  haveADiscountCode: "HAVE A DISCOUNT CODE?",
  inStoreCollection: "IN STORE COLLECTION",
  invalidPostalCode: "Invalid Postal Code",
  invalidcardNumber: "Invalid Card Number",
  leaveatMyDoorDesc: "安全のため、非接触デリバリーを実施しております。ドライバーはご注文の商品を玄関扉の近くに置き、インターフォンを鳴らしてから扉から距離を置いた場所に移動し、お客様が安全に商品を受け取ることができるようにいたします。",
  locationDeniedMsg: "KFC would like to process your location data to find nearby restaurants, send local deals, rewards and news, and to personalize and localize or user experience as described in our Privacy Statement.",
  loveToHearFromYou: "We'd love to hear from you.",
  managePreferences: "Manage Preferences",
  nameExistMsgSaved: "違う住所登録名で設定してください。",
  namevalidationmsg: "special characters are not allowed",
  noLongerServeText: "Can No Longer Serve This Order.",
  noOrderHistoryMsg: "Your Bucket is empty. Let’s start an order!",
  noStoreTextDineIn: "OOps! Sorry, there are no stores available for Dine In.",
  oneCouponPerOrder: "You can only apply one coupon per order.",
  openProductFilter: "Open product filter",
  orderGettingReady: "WE’RE GETTING YOUR ORDER READY",
  otpInvalidMessage: "Invalid verification code",
  phoneNumberStatic: "1300 666 532",
  popoverDoneButton: "Done",
  postOrderAccepted: "ORDER ACCEPTED.",
  postOrderErrorMsg: "It seems there is some issue with the order status",
  preparedByHeading: "Prepared by double tap to activate",
  priceChangeNotify: "Items in your cart have changed price.",
  pushNotifications: "Push Notifications",
  "quote OrderNumber": "QUOTE YOUR ORDER NUMBER #",
  refineItemsHeader: "Refine items",
  reorderFavourites: "おすすめ情報を受け取ったり、お気に入りを再注文したりできます",
  returnedNoResults: "該当する検索結果はありません",
  saveOrderThankYou: "Thank you for signing up!",
  savetoaddressbook: "このお届け先住所をアドレス帳に保存する",
  secretMenuContext: "Discover unreleased treats that have never seen the light of day – until now... This menu is updated regularly so keep checking back!",
  selectionNotSaved: "Your selections aren’t saved.",
  setManualLocation: "Set up Manually",
  surveyScreenTitle: "Survey",
  termsAndCondition: "Terms & Conditions",
  willYouBeOrdering: "Which menu will you be ordering from today?",
  yourEmailHelpText: "Please enter your Email ID.",
  BuildYourOwnBucket: "Build Your Own Bucket",
  Page_Order_Details: "KFC - Order Details",
  Page_Title_Account: "KFC Account",
  addressPlaceHolder: "お気に入り店舗＆住所",
  bothChangeCartMain: "NO LONGER AVAILABLE / HAVE CHANGED PRICE.",
  bothChangeCartText: "ITEMS IN YOUR CART ARE",
  cartOffersAndDeals: "Offers & Deals",
  cartRecommendTitle: "ご一緒にいかがですか",
  cateringPromoError: "Promotion not available with Catering orders",
  changedItemOneItem: "Item have changed price.",
  clearCartAwareText: "please be aware that ",
  codeExpiredMessage: "Your code has expired",
  defaultAddressName: "Addresses ",
  defaultCallMessage: "Meanwhile,",
  deliveryOptionsVal: "deliveryOptions",
  dineInNotAvailable: "Dine-in is not available would like to go for Pick up instead?",
  emptyFavouriteMenu: "You haven’t favourited any items yet",
  enterYourOrderName: "Enter Order name input field",
  errorMessageClosed: "Sorry , the restaurant is closed on the date and time you have chosen . Choose another date and time",
  favouriteMenuTitle: "お気に入り",
  giftCardNumberText: "Gift Card Number*",
  invalidEmailErrMsg: "メールアドレスが無効です。",
  invalidQRCodeError: "Invalid QR code, would you like to explore nearby KFC store",
  isCheckedInCooking: "IS CHECKED IN AND COOKING",
  itemAddedToCartMsg: "Please note your items will be added to your cart.",
  lastOrderCheckInAt: "LAST ORDER CHECK IN at ",
  letUsUseUrLocation: "PLEASE LET US USE YOUR LOCATION.",
  messageplaceholder: "Leave a message for recipients here.",
  mobileErrorMessage: "有効な電話番号を入力してください",
  noDeliveryErrorMsg: "can’t deliver to the address entered. Available delivery restaurants below.",
  noTimeSlotsMessage: "Timeslots are not available right now",
  nutrition_allergen: "Nutrition and Allergen Information",
  openTodayWithoutAt: "Open Today",
  pdpRegularSizeDesc: "Regular chips & drink",
  pdpRgularSizeTitle: "レギュラーサイズ",
  postOrderScheduled: "scheduled!",
  productUnavailable: "取り扱いがない商品",
  promosUnmetMessage: "Promo conditions unmet to Checkout:",
  purchasefailuremsg: "It seems there is some issue with the Gift card purchase",
  quantityUpdateText: "Quantity updated to",
  readyInJustASecond: "READY IN JUST A SECOND.",
  readyToPrepareMeal: "出来たてのおいしいお食事をご用意いたします。",
  restaurantHandling: "Delivery Fee",
  savedAddressesText: "住所が保存されました",
  searchResultHeader: "results for",
  seeCustomisedItems: "See customised items",
  selectPickupMethod: "受取方法を選択",
  selectYourLanguage: "Select Your Language",
  somethingWentWrong: "Something went wrong please try after sometime",
  storeCloseSoonMain: "is closing in 45 minutes",
  storeContainerText: "Let’s order for Takeaway or delivery",
  storeUseMyLocation: "Use My Location",
  unsupportedBrowser: "This browser is not supported by KFC App. Please download these browsers to use this app.",
  userRefreshWarning: "Your session is going to expire soon. Please continue your work once your page reloads",
  vehicleInformation: "Enter your vehicle information (brand, color, etc)",
  viewMapErrorButton: "地図を表示する",
  weArePreparingMeal: "We’re preparing your meal",
  weThinkYouLoveThis: "We Think You'll love these",
  MyDeliveryAddresses: "お届け先住所",
  Page_Title_Checkout: "KFC Checkout",
  Page_Title_Our_Adds: "KFC Our Adds",
  Page_Title_Sign_out: "KFC Signout",
  address2Placeholder: "Apartment, suite, unit, building, floor",
  appCrashPopupHeader: "SOMETHING WENT WRONG!",
  bothChangeCartQuery: " DO YOU WANT TO KEEP THESE SETTINGS?",
  categoriesImageText: "Browse categories",
  changeOrderSettings: "Change Order Settings",
  clearCartActionText: "your cart will be cleared ",
  createAccountToSave: "CREATE AN ACCOUNT TO SAVE YOUR ORDERS AND CHECKOUT FASTER",
  creditDebitCardText: "Credit / Debit Card",
  defaultCallMessages: "please call",
  defaultErrorMessage: "Thank you for visiting. We are fixing this right away. Will be back soon.",
  deleteOccassionText: "Delete this Occassion",
  deliveryAddressText: "お届け先住所",
  deliveryInstruction: "Please Enter Delivery Instruction",
  deliveryStoreClosed: "Sorry, delivery is not currently available right now.",
  dismissChangesAlert: "選択が保存されていません。",
  doubleTapToActivate: "double tap to activate",
  driveThruCollection: "DRIVE THRU COLLECTION",
  editItemSuccessText: "You have successfully edited an item in your cart.",
  emptyFullNameErrMsg: "Enter your full name.",
  emptyLastNameErrMsg: "[姓] を入力してください。",
  emptyYourNameErrMsg: "Please enter your name.",
  enquiryDetailsError: "お問い合わせ内容を入力してください",
  enterContactDetails: "Enter Contact Details",
  favoriteItemMessage: "Item added to favourites",
  favouriteNameUpdate: "名前を更新する",
  findClosestLocation: "Find your closest location.",
  foundDeliveryDriver: "we’VE FOUND A DELIVERY DRIVER",
  giftCardInformation: "GIFT CARD INFORMATION",
  giftCardPurchageMsg: "Your gift card has been purchased and details emailed to the recipient",
  iAmAtDriveThruQueue: "I’m at the Drive Thru line",
  iAmInsideRestaurant: "お店に到着",
  insufficientBalance: "Insufficient Balance",
  lastNamePlaceHolder: "姓*",
  locationDeniedTitle: "Please Let us Use your location.",
  noStoreTextTakeaway: "OOps! Sorry, there are no stores available for Pick up.",
  occassionNameExists: "Occasion name already exists",
  onChangeWelcomeBack: "Welcome Back!",
  pdpAllergyNutrition: "アレルギー・原産地情報など",
  phcWheelChairAccess: "バリアフリー",
  pleaseEnterLocation: "Please enter your location",
  postOrderErrorMsgAU: "注文手続きで問題が発生しました。お支払いができませんでした。",
  quantityDecreseText: "Decreases quantity by 1 item for",
  readyToStartCooking: "You sure you’re ready for us to start cooking?",
  removeFromFavourite: "お気に入りから削除する",
  savedeliveryaddress: "Save Delivery Address",
  seeFullOrderHistory: "See Full Order History",
  selectOrderSubTitle: "Menu availability and pricing may vary between order types.",
  signInToYourAccount: "アカウントにログインする",
  sitTightCallOutText: "sit tight We’ll CALL OUT YOUR NAME WHEN it’s READY",
  socialNetworkingBtn: "Social Networking Site ",
  splahScreenGreeting: "NICE MEETING YOU",
  storeOfflineContent: "Please find another nearby restaurant.",
  takeawayStoreClosed: "Sorry, pick up is not currently available right now.",
  unavailableCartMain: "NO LONGER AVAILABLE",
  unavailableCartText: "SORRY, SOME ITEMS ARE",
  unsuccessfulPayment: "It seems there is some issue with the order status",
  usernameplaceholder: "Your Name*",
  verificationMessage: "Please enter the verification code we just sent to:",
  Page_Title_ContactUs: "KFC Contact Us",
  Page_Title_Gift_Card: "KFC Gift Card",
  Page_Title_Not_Found: "KFC Page not found",
  allergenTraceDetails: "商品（およびその原材料）の製造場所でアレルギ―物質を含む製品が製造・調理、または保管されています。",
  cateringCartErrorMsg: "Catering Orders require 24 hours advance notice to Checkout.",
  changeYourOrderTitle: "CHANGE YOUR ORDER",
  clearSearchOrderName: "検索をクリアする",
  currentlyUnavailable: "Currently unavailable",
  deleteAccountMessage: "are you sure you want to delete your account",
  deliveryInstructions: "Enter delivery instructions(Optional)",
  dispositionUnavalMsg: "Sorry, %disposition% is currently unavailable. Please change your order settings below to complete your order.",
  editorPickupSubTitle: "Receive Editor updates on new and upcoming releases and the best reviews from customers like you",
  emptyFirstNameErrMsg: "[名] を入力してください。",
  errorMessageInactive: "Damn! We can’t check out your order, keep trying or alternatively please visit the store.",
  favoriteStoreMessage: "This store is marked as your favourite",
  findNearByRestaurant: "Find nearby restaurant",
  firstNamePlaceholder: "名*",
  invalidAddressHeader: "残念ながら、ご住所を特定できませんでした。詳しい住所を指定してください。",
  largeCarryBagContent: "₹5.00 Tick to add a large carry bag.",
  lastNameErrorMessage: "Please enter a valid last Name",
  locationBlockedError: "You have blocked from KFC accessing your location. Go to your Browser settings and enable %kfcUrl% to Use My Location.",
  mobileToolTipMessage: "ご注文についてのご連絡をする場合があるため、電話番号は必須です。",
  myFavouriteMenuTitle: "My Favourite Menu",
  nonAlaCarteAlertLink: "栄養成分＆アレルギー情報ガイドを表示する",
  nonAlaCarteAlertText: "この商品の個々のアイテムのアレルギー情報を表示する",
  optionalEmailAddress: "Email Address",
  orderTakeAwayBtnText: "Order Pick up",
  pickupCancalledOrder: "Your pick up order has been cancelled.",
  priceChangedCartMain: "CHANGED PRICE.",
  priceChangedCartText: "ITEMS IN YOUR CART HAVE",
  quantityIncreaseText: "Increases quantity by 1 item for",
  saveToFavouriteOrder: "お気に入り注文に保存する",
  savedDeliveryAddress: "Saved your Delivery Address",
  savedDeliveryOptions: "デリバリーオプション",
  scheduleForYourOrder: "Schedule for your order",
  selectDifferentStore: "Please select a different restaurant or keep browsing the menu",
  selectYourBankHeader: "Select Your Bank",
  suggestedSearchTerms: "おすすめの検索語句",
  surveyScreenQuestion: "How was your order?",
  takeawayNotAvailable: "Pick up is not available would like to go for Dine-in instead?",
  unavailableCartQuery: "AT THIS LOCATION. DO YOU WANT TO KEEP THESE SETTINGS?",
  unavailableUppercase: "UNAVAILABLE",
  useMyLocationBtnText: "Use My Location",
  useremailplaceholder: "Your Email*",
  userphoneplaceholder: "Your Phone Number*",
  verificationOTPLabel: "Verification code",
  willBeReadyForPickup: "Will be ready for pick up by",
  Page_Title_Post_Order: "KFC Post Order",
  Page_Title_TermsOfUse: "KFC Terms of use",
  accountSignOutMessage: "are You sure you want to sign out of your account?",
  addHopeSubDescription: "Our goal is to feed 20 millions meals by 2021.",
  addedToYourFavourites: "Added to Your Favourites",
  addresss2InvalidError: "Special characters are not allowed except ,/#@-().",
  apiFailurePopupHeader: "SOMETHING WENT WRONG!",
  billingPostalCodeText: "Billing Postal Code*",
  canNotDeliverErrorMsg: "can’t deliver to the address entered. Available delivery restaurants below.",
  cancelOrderButtonText: "Cancel Order",
  checkGiftBalanceTitle: "Check your Gift card balance",
  clearCartCompleteText: "to complete this order.",
  confirmYouAreHereText: "We'll start prepping your order now, so make sure you're here or very near!",
  editCurrentRestaurant: "edit your kfc restaurant",
  editSelectionsBtnText: "Edit selections",
  firstNameErrorMessage: "Please enter a valid First Name",
  inlineSavedAddressMsg: "同じ住所登録名が既に設定されています。",
  invalidFullNameErrMsg: "Invalid full name.",
  invalidLastNameErrMsg: "Invalid last name.",
  keepPrevOrderSettings: "WOULD YOU LIKE TO KEEP Your PREVIOUS order SETTING?",
  maxOrderAmountMessage: "The max order amount for store is",
  minOrderAmountMessage: "The min order amount for store is",
  myFavouriteBrowseMenu: "Browse the menu",
  openTomorrowWithoutAt: "Open Tomorrow",
  otpCodeExpiredMessage: "Your code has expired!",
  pleaseReviewYourOrder: "Please review your order",
  priceChangedCartQuery: " DO YOU WANT TO KEEP THESE SETTINGS?",
  purchasefailureheader: "OH NO!",
  searchDiffAddressText: "Search for a different address",
  storeCloseSoonContent: "Complete your order and checkout within\n 15 minutes, or find another nearby store.",
  storeClosedButtonText: "Store Closed",
  testingLingualSupport: "English",
  unFavoriteItemMessage: "Item removed from favourites",
  wantToKnowPlaceholder: "Type your message here.",
  yourCateringOrderWill: "YOUR CATERING ORDER WILL",
  NoBasketIdErrorMessage: "We were not able to fetch your cart details due to an unexpected error. To continue further please select the store to continue.",
  OccasionNameValidation: "Name cannot contain special characters",
  PercentDailyValuesText: "*1 日 2,000 カロリーを基準とした標準栄養成分%",
  addPaymentMethodHeader: "お支払い方法を追加",
  allergenPresentDetails: "アレルゲンを含む原材料、添加物、加工助剤を使用。",
  callOutWhenMealIsReady: "We'll call your name when your finger lickin' meal is ready.",
  cartCouponErrorMessage: "Sorry, this code isn’t available right now.",
  cateringClosedStoreMsg: "Uh oh, looks like this KFC store has closed, so you won’t be able to order here now.",
  cateringToMenuNavTitle: "Just a Quick Heads Up",
  connectWithASpecialist: "スペシャリストに質問する。",
  deliveryAddressDeleted: "Delivery Address Deleted",
  emptyPhoneNumberErrMsg: "電話番号を入力してください",
  feedbackSuccessMessage: "Thanks for submitting your query. We will get back soon.",
  giftcardpaymentfailure: "Unfortunately, we can't process this payment, as the payment has been declined by your credit card Issuer or bank",
  induldentAddOnsHeading: "We reckon you’ll also love these...",
  invalidFirstNameErrMsg: "[名] が無効です。",
  locationDifferentError: "お客様の位置情報は、以前のご注文時と異なっております。変更をクリックして、下記のお気に入り店舗を更新してください。",
  menuToCateringNavTitle: "通常メニューからご注文いただいているため、ケータリングはできません。",
  myFavouriteMenuNoItems: "You haven't favourited any items yet",
  myOccassionUnavailable: "You haven't added any favourite orders yet",
  orderNoLongerCheckedIn: "This order can no longer be checked.",
  orderNumberPlaceHolder: "Order Number*",
  pickupInsideRestaurant: "Pick up your order at the counter inside the restaurant",
  placePinAtYourLocation: "Place the pin at your location.",
  postalcodeErrorMessage: "有効な郵便番号を入力してください",
  removeFromFavOrdersMsg: "この注文をお気に入りから削除しますか？",
  selectYourWalletHeader: "Select Your Wallet",
  storeClosedServerTitle: "can no longer serve this order.",
  subscribedToastMessage: "正常に配信登録されました",
  thankYouCommentMessage: "Your comments have been received and we will get back to you shortly",
  tickToAddLargeCarryBag: "Tick to add a large carry bag.",
  unFavoriteStoreMessage: "This store is removed from your favourites",
  addressNickNameOptional: "住所登録名（任意）",
  addressSuggestionHeader: "住所をご確認ください。",
  cartCateringContentText: "Please select a later time or date, or contact the store by phone.",
  checkoutNoSignInMessage: "Please Sign In or Sign Up above to add a Payment Method and Checkout.",
  closeStoreModelSubTitle: "Please select a different store or order during working hours.",
  completeOrderButtonText: "Complete order",
  continueAsGuestCheckout: "ゲストとして注文する",
  dineInPickDifferentTime: "Dine-In is not available for the selected time, please select different time.",
  emergencyStoreCloseMain: "is currently closed due to unforseen circumstances",
  emptySearchResultHeader: "Your search did not end up in any results",
  enterDifferentOrderName: "同じ名前がすでに存在しています。別の注文名を入力してください。",
  invalidCharactersErrMsg: "Numbers and special characters are not allowed.",
  invalidYourEmailErrText: "Please Enter Correct Email Address",
  locationDeniedTitleCaps: "PLEASE LET US USE YOUR LOCATION.",
  lookingForSpecificOrder: "Looking for a specific order?",
  mobileNumberWithAstrick: "Mobile Number*",
  networkIssuePopupHeader: "SOMETHING WENT WRONG!.",
  orderTypeDifferentError: "以前のご注文は $previousOrderType でしたが、今回は $currentOrderType としてご注文されています。下記をご確認の上、必要に応じて変更をクリックし、更新してください。",
  pickupPickDifferentTime: "Pick up is not available for the selected time, please select different time.",
  savedAddressHeaderTitle: "お気に入り店舗＆住所",
  savedOrderScheduleOrder: "Scheduled Order ",
  searchNutritionAllergen: "Search Nutrition & Allergen Guide",
  surveyScreenSubQuestion: "Write a review",
  weveFoundDeliveryDriver: "お届けするドライバーが見つかりました",
  Page_Title_Cart_Checkout: "KFC Checkout",
  appCrashPopupDescription: "Whoops, something went wrong! Please restart the app",
  cannotContainSpecialChar: "特殊文字は使用できません。",
  cartCateringAlertEndText: "to checkout",
  cartSelectDifferentStore: "Please find another nearby restaurant.",
  communicationPreferences: "希望される連絡受け取り方法",
  deliveryAddressLineLabel: "Apt / Suite / Floor (Optional)",
  deliveryPartnersDoordash: "doordash",
  editOccassionDialogTitle: "Edit Occasion Name",
  enterQuestionPlaceholder: "| 質問、または検索語句を入力",
  enterYourDeliveryAddress: "お届け先住所を入力",
  favouriteNameLengthError: "Favourite Name has to be atleast 3 char length",
  invalidCustomerInfoError: "Invalid customer details. Please update it from Account Settings page.",
  invalidPhoneNumberErrMsg: "Invalid phone number.",
  itemCurrentlyUnavailable: "現在ご利用いただけません",
  kfcSignInExclusiveOffers: "Sign in to see more exclusive offers & deals",
  kfcSignInExclusivePromos: "ログインして限定プロモーション & 特典を見る",
  noPaymentOptionAvailable: "No payment option available.",
  noStoresWithDineInHeader: "Sorry, dine-in is not currently available for this address.",
  noStoresWithPickupHeader: "Sorry, pick up is not currently available for this address.",
  "nutration-allergen-guide": "栄養成分＆アレルギー情報について",
  phonenumberEmptyHelpText: "Please enter your phone number.",
  promosRemoveConfirmation: "このプロモーションを削除しますか？",
  promosRemoveToastMessage: "Promo removed from Order",
  promosSuceesToastMessage: "Promo added to your Order",
  receiveSpecialOffersText: "RECEIVE SPECIAL OFFERS AND REORDER YOUR FAVOURITES",
  savedOrderInFavoriteMenu: "Saved this order in My Favourite Menu.",
  totalOrderErrorOverlimit: "Whoops Total order is over",
  unsubscribedToastMessage: "正常に配信停止されました",
  wereMakingYourOrderFresh: "ただいまご用意しております",
  wereReadyToMakeYourOrder: "ご注文をご用意する準備が整いました",
  IsOnHisWayToTheRestaurant: "はKFCの店舗に向かっています",
  Page_Title_Payment_Status: "KFC Payment Status",
  Page_Title_Privacy_Policy: "KFC Privacy Policy",
  addContactToEnablePayment: "お支払い方法を追加できるようにするには上記連絡先情報を追加してください。",
  cancelDeliveryOrderRefund: "YOUR ORDER WILL BE REFUNDED IN FULL WITHIN 7 BUSINESS DAYS",
  cateringConfirmationEmail: "An confirmation email has been sent and a store manager will contact you on Pick Up day to ensure its cooked at the exact right time",
  deleteAddressConfirmation: "お届け先住所を削除しますか？",
  deleteDeliverySaveAddress: "Delivery Address Deleted",
  deliveryPickDifferentTime: "Delivery is not available for the selected time, please select different time.",
  doubleTaptoStartYourOrder: "double tap to open start your order page",
  giftcardCheckbalnaceTitle: "CHECK YOUR GIFT CARD BALANCE",
  invalidPhoneNumberErrText: "Not a valid phone number",
  invalidVehicalInformation: "Invalid Vehicle Information",
  multipleCustomizationText: "This item has multiple customizations added. Proceed to cart to remove item?",
  pleaseEnterAValidLastName: "Please enter a Valid last Name",
  postProcessIngGstIncluded: "合計額（税込）:",
  promosUnmetSummaryMessage: "Promo conditions not met, view Promo/s in Cart for details.",
  recipientemailplaceholder: "Recipient Email*",
  storeClosePickupOrderMode: "Pick Up from this store is currently unavailable, change to Delivery for this store to fulfill your order.",
  storeUnavailableForPickup: "Pick Up from this store is currently unavailable, change to Delivery for this store to fulfill your order.",
  valideDayAndMonthRequired: "Valid Day, Month are required to submit",
  Page_Title_Payment_Failure: "KFC Payment Failure",
  Page_Title_Payment_Success: "KFC Payment Success",
  apiFailurePopupDescription: "Whoops, something went wrong! Please try again.",
  cartCateringAlertStartText: "Sorry, catering orders require 24 hours advance notice",
  createAndAccountSaveOrders: "CREATE AN ACCOUNT TO SAVE YOUR ORDERS AND",
  dineInNoStoresFoundMessage: "No restaurant has been found for Dine-In. Please try another location.",
  dineInUnavailableErrorText: "Dine-In is currently unavailable for your location. Would you like to order pick up instead?",
  emergencyStoreCloseContent: "Find another nearby restaurant or\n close to keep browsing the menu",
  invalidDeliveryInstruction: "Invalid Delivery Instruction",
  invalidPhoneErrforGiftCard: "Invalid Phone Number, Please enter valid Phone Number",
  noStoresWithDeliveryHeader: "残念ながら、入力された住所に配達サービスを行っている店舗が見つかりませんでした。",
  paymentPreValidationFailed: "Unfortunately, we are unable to process your payment right now. Please try with a different payment option.",
  pickupNoStoresFoundMessage: "No restaurant has been found for Carryout. Please try another location.",
  pleaseEnterAValidFirstName: "Please enter a Valid First Name",
  removedFromFavouriteStores: "Removed from Favourite Stores",
  saveOrderAndCheckoutFaster: "SAVE YOUR ORDERS AND CHECKOUT FASTER",
  someoneElseCollectingOrder: "someone else collecting the order?",
  unidentifiedAddressMessage: "Sorry, we could not identify your address. Please be more specific by moving the map.",
  Page_Title_Terms_Conditions: "KFC TERMS & CONDITIONS",
  cateringToMenuNavContentMsg: "This will end your Catering Order and take you to the Regular Menu to start a new order. Any Catering menu items in your cart will be removed.",
  clickPlaceOrderConfirmAgree: "[注文する] をクリックすることにより [] に同意したものとみなされます",
  closeStoreModelSubNearTitle: "Please find another nearby restaurant.",
  dispositionItemNotAvailable: "Not available for ",
  enterYourOrderNoPlaceHolder: "Enter Your Order Number",
  freeDeliverywithWickedWings: "Free Delivery with Wicked Wings",
  induldentAddOnsAddedMessage: "Item added to your Order",
  menuToCateringNavContentMsg: "ケータリングメニューから新たに注文を開始すると、カート内の通常メニューが削除されます。",
  previousOrderDataSettingMsg: "WOULD YOU LIKE TO KEEP Your PREVIOUS order SETTING?",
  recipientEmptyEmailHelpText: "Please enter the Recipient's Email ID.",
  selectYourOtherWalletHeader: "Select Your Other-Wallet",
  storeCloseDeliveryOrderMode: "Delivery from this store is currently unavailable, change to Pick Up for this store to fulfill your order.",
  storeUnavailableForDelivery: "Delivery from this store is currently unavailable, change to Pick Up for this store to fulfill your order.",
  takeAwayUnavalibleErrorText: "This KFC is not accepting online orders. Please try another KFC near you or check back later.",
  totalOrderErrorBetweenlimit: "Whoops total order is not between",
  cartRemoveSingleItemNextText: "from your cart?",
  cartRemoveSingleItemPrevText: "Are you sure to remove",
  deliveryNoStoresFoundMessage: "Hey, the nearest KFC store to your location is currently not accepting online orders. Please try another location or check again later.",
  deliveryUnavailableErrorText: "Delivery is currently unavailable for your location. Would you like to order pick up instead?",
  exceededVerificationAttempts: "認証コードの試行回数が上限に達しました（3/3）。情報は保存されていません。",
  infoMakeSureRightNumberEmail: "Please make sure this is the right number and email address, just in case we need to contact you for this order. We won't spam you, promise.",
  invalidRecipientEmailErrText: "Please Enter Correct Email Address",
  networkIssuePopupDescription: "We’re sorry, we’re having trouble with your connection. Please check your WiFi or mobile service and try again.",
  suggestionlocationTextPickup: "Suggested locations",
  areYouSureToDeleteAccountText: "アカウントを削除しますか？",
  cartRemoveAllConfirmationtext: "Are you sure to remove all of items in your cart?",
  hasAcceptedToDeliverYourOrder: "has accepted to deliver your order",
  selectYourPaymentScreenHeader: "Select Your Payment",
  valideDayMonthAndYearRequired: "Valid Day, Month and Year are required to submit",
  deliveryIsCurrentlyUnavailable: "現在、配達サービスを行っておりません",
  cartError_sorryFoodNotAvailable: " currently, continue exploring.",
  noStoresWithDeliveryHeaderError: "Delivery is currently unavailable for your entered location. Could you be more specific with address or would you like to try pick up instead?",
  cartEditLineItemConfirmationtext: "You have successfully edited an item in the cart.",
  loremIpsumDolorSitAmetConjuncivus: "LOREM IPSUM DOLOR SIT AMET CONJUNCIVUS",
  pleaseEnterYourVehicalInformation: "Please Enter Your Vehicle Information",
  cartRemoveLineItemConfirmationtext: "Item has been removed from your cart.",
  takeAwayUnavalibleErrorTextWithCTA: "Pick up is currently unavailable for your location. Would you like to try a different address?",
  addressBoxPlaceHolderForSearchStore: "住所、郵便番号で検索",
  deliveryUnavailableErrorTextWithCTA: "Sorry, we could not identify your address. Please be more specific with your location.",
  dineInStoresWithoutAnyServiceHeader: "Sorry, dine-in is not currently available right now. Would you like to schedule for later?",
  informToContactNominatedPersonOrder: "We will only use this information to contact the nominated person about the order.",
  pickupStoresWithoutAnyServiceHeader: "Sorry, pick up is not currently available right now. Would you like to schedule for later?",
  deliverystoresWithoutAnyServiceHeader: "Sorry, delivery is not currently available right now. Would you like to schedule for later?",
  itsBusyAndItsTakingAWhileToFindADriver: "現在込み合っておりドライバーを確保するのに時間がかかっております...",
  cartEditLineItemConfirmationtextMessage: "You have successfully edited an item in your cart.",
  aditionalAddress: "ビル・マンション名 / 階（省略可",
  firstCarousel: "期間限定",
  myFavouritelabel: "お気に入り店舗",
  deliveryInstructionAddress: "デリバリー特記事項",
  makeDefaultAddress: "既定の住所に設定する。",
  itemInTheOrderUnavailable: "この注文に含まれる商品は、現在この店舗ではご利用いただくことができません。",
  pickUpTime: "PICK UP TIME",
  deliveryTime: "DELIVERY TIME",
  selectPickupTime: "Select pick up time",
  scheduledTimePassed: "Your scheduled time has passed, please select a new time to proceed.",
  breakfastMenu: "Breakfast menu available till 11am",
  addresses: "My Stores & Addresses",
  selectDeliveryTime: "Select delivery time",
  rescheduleOrderTime: "Reschedule Order Time",
  selectAnotherTime: "Select another time to receive your order.",
  deliveryLocation: "DELIVERY LOCATION",
  removeAllUnavailableItem: "Remove all unavailable items",
  menuKickedInUnavailableCart: "Lunch menu has kicked in",
  removeUnavailableItemsInCart: "remove unavailable items in cart",
  checkoutUnavailable: "Items in your cart are currently available. Please remove the items from your",
  toContinue: "to continue.",
  scheduleTimeCrossed: "Your scheduled\n order time has passed",
  scheduledCaps: "SCHEDULED",
  deeplinkCategoryNotAvailable: "Sorry, THIS CATEGORY IS NOT AVAILABLE FOR THE SELECTED RESTAURANT.",
  iWillPayNow: "今支払います",
  iWillPayWhenIPickUp: "受け取り時に支払います",
  paymentTermsOfUseText: "利用規約とプライバシーをご覧ください.",
  paymentSectionTitle: "支払い方法",
  promoAddToCart: "Add to Order",
  storesNotServingCurrently: "Sorry! Your store is not serving orders currently",
  "For Members Only": "会員限定",
  changeLanguage: "Change language",
  orderScheduled: "ORDER SCHEDULED",
  storeClosedAndPickUpApplied: "The store is currently closed, the next available pick up time has been applied",
  legalInfoPLPFooter1: "The average adult daily intake is 8700kJ.",
  legalInfoPLPFooter2: "^ Pepsi Max, Pepsi, Pepsi Freeze & Mountain Dew Freeze contains caffeine. Mountain Dew Freeze is not recommended for children, pregnant or lactating women or individuals sensitive to caffeine.",
  goodMorning: "Good Morning",
  goodAfternoon: "Good Afternoon",
  noKfcNearYou: "Sorry, there is no KFC near you",
  meetAtVehicle: "Meet at vehicle",
  couponErrMsgBSDE0022: "This coupon code is already redeemed.",
  couponErrMsgBSBR003: "This coupon code is incorrect.",
  monday: "monday",
  tuesday: "tuesday",
  wednesday: "wednesday",
  thursday: "thursday",
  friday: "friday",
  saturday: "saturday",
  sunday: "sunday",
  editAddress: "EDIT DELIVERY ADDRESS",
  signedOut: 'You’re signed Out. We’re gonna miss you.',
  kfcStore: 'KFC store',
  outOfStockProductText: 'A product or ingredient is currently unavailable. Please review the required selections below to add to order.',
  addressLabel: 'Address',
  postalCode: 'Postal Code',
  cityTown: 'City / Town',
  state: 'State'
}, _defineProperty(_translation, "deliveryInstructionAddress", 'Delivery Instructions'), _defineProperty(_translation, "makeDefaultAddress", 'Make this my default address'), _defineProperty(_translation, "aditionalAddress", 'Apt / Suite / Floor (Optional)'), _defineProperty(_translation, "labelPostalCode", "Postal Code"), _defineProperty(_translation, "thereNoFriedText", "THERE'S NO FRIED"), _defineProperty(_translation, "chickenOnThisPage", "CHICKEN ON THIS PAGE"), _defineProperty(_translation, "giftCardPurchaseSuccess1", "YOUR GIFT CARDS"), _defineProperty(_translation, "giftCardPurchaseSuccess2", "ARE ON THE WAY"), _defineProperty(_translation, "giftCardPurchaseMsg", "Your reciepients will recieve an SMS shortly."), _defineProperty(_translation, "returnToGiftCards", "Return to Gift Cards"), _defineProperty(_translation, "christmasOrdering", 'Christmas Ordering'), _defineProperty(_translation, "search", 'Search'), _defineProperty(_translation, "chome", 'Chome'), _defineProperty(_translation, "prefecture", 'Prefecture'), _defineProperty(_translation, "streetDetailAddress", 'Street / Detailed Address'), _defineProperty(_translation, "apartmentName", 'Apartment Name (Optional)'), _defineProperty(_translation, "roomNumber", 'Room No. (Optional)'), _defineProperty(_translation, "companyName", 'Company Name (Optional)'), _defineProperty(_translation, "specialNote", 'Special Note (Optional)'), _defineProperty(_translation, "otherDeliveryServices", 'Other services available for delivery'), _defineProperty(_translation, "storesVaryMessage", 'The area and number of stores may vary depending on each service.'), _defineProperty(_translation, "confirmLocation", 'Confirm Location'), _defineProperty(_translation, "searchDeliveryLocation", 'Search for delivery location'), _defineProperty(_translation, "scheduleYourOrder", 'SCHEDULE YOUR ORDER'), _defineProperty(_translation, "specialNoteDetail", 'Special Note : '), _defineProperty(_translation, "tipExceedsSubtotal", 'Tip exceeds Subtotal'), _defineProperty(_translation, "noResults", "RETURNED NO RESULT"), _defineProperty(_translation, "serves", "Serves"), _defineProperty(_translation, "myFavouritelabel", "MY FAVOURITE STORES"), _defineProperty(_translation, "myDeliveryAddresses", "MY DELIVERY ADDRESSES"), _defineProperty(_translation, "yourorders", "YOUR ORDERS"), _defineProperty(_translation, "orderAgainBtn", '再度注文する'), _defineProperty(_translation, "quoteOrderNumber", '注文番号 # を引用してください'), _defineProperty(_translation, "cardValidatingTitle", '検証中'), _defineProperty(_translation, "newCardText", '新しいカード'), _defineProperty(_translation, "cardValidationDesc", "決済プロバイダーでカードを検証中です"), _defineProperty(_translation, "removeGiftCard", "REMOVE GIFT CARD"), _defineProperty(_translation, "giftCardContent", 'Are you sure you would like to remove this Gift Card?'), _defineProperty(_translation, "removeVoucher", 'REMOVE VOUCHER'), _defineProperty(_translation, "voucherContent", 'Are you sure you would like to remove this Voucher?'), _defineProperty(_translation, "giftCardMealFullyCovered", "Woohoo! Your Gift Card has covered your meal."), _defineProperty(_translation, "voucherMealFullyCovered", 'Woohoo! Your voucher has covered your meal.'), _defineProperty(_translation, "voucherAboveSubtotal", 'Vouchers are single use. Balance above meal subtotal can not be used again.'), _defineProperty(_translation, "giftCardAboveSubtotal", 'Woohoo! Your Gift Card has covered the meal. Use your remaining balance another time.'), _defineProperty(_translation, "maxSubTotalValueCovered", 'Maximum order subtotal limit has been reached.'), _defineProperty(_translation, "maxVoucherLimitExceeded", 'The maximum number of Gift vouchers has been applied.'), _defineProperty(_translation, "giftCardToast", "Gift Card Removed"), _defineProperty(_translation, "voucherToast", "Voucher Removed"), _defineProperty(_translation, "giftCardVoucherContent", "The added vouchers/gift cards will be cleared if you update the cart. Do you want to continue?"), _defineProperty(_translation, "removeGiftCardVoucher", "CLEAR VOUCHER/GIFT CARD"), _defineProperty(_translation, "postOrderCouponFailure", "Your time to redeem a gift card or voucher has expired. Please re-apply at Cart and proceed to Checkout."), _defineProperty(_translation, "reApplyGiftCardOrVoucher", 'Please re-apply a valid gift card or voucher code to your order.'), _defineProperty(_translation, "savedCardPaymentTitle", "Saved cards"), _defineProperty(_translation, "otherPaymentTitle", "Use Other Payment Method"), _translation);
exports.translation = translation;